export class DataTableHeader {
    public key: string;
    public name: string;
    public sort: string;
    public sortType: string;
    public width: number;
    public align: string;
    public isShowSortSearch: boolean;
    public isColumnFilter: boolean;
    constructor (options: {
        key?: string,
        name?: string,
        sort?: 'asc' | 'desc' | '',
        sortType?: 'alphabetical' | 'number' | 'date' | '',
        width?: number,
        align?: 'left' | 'center' | 'right' | '',
        isShowSortSearch?: boolean
        isColumnFilter?: boolean
    } = { key: '', name: '', sort: '', sortType: '', width: 0}) {
        this.key = options.key || '';
        this.name = options.name || '';
        this.sort = options.sort || '';
        this.sortType = options.sortType || '';
        this.width = options.width || 0;
        this.align = options.align || '';
        this.isShowSortSearch = options.isShowSortSearch || false;
        this.isColumnFilter = options.isColumnFilter || false;
    }
    
}